import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'AfterSaleAllocation',
    column_type: 'id',
  },
  created_at: {
    model_name: 'AfterSaleAllocation',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'AfterSaleAllocation',
    column_type: 'datetime',
  },
  sales_order: {
    model_name: 'AfterSaleAllocation',
    column_type: 'belongs_to',
    extra: {
      association_name: 'sales_order',
      model_name: 'SalesOrder',
    },
  },
  sales_order_id: {
    model_name: 'AfterSaleAllocation',
    column_type: 'belongs_to',
    extra: {
      association_name: 'sales_order',
      model_name: 'SalesOrder',
    },
  },
  jushuitan_after_sale: {
    model_name: 'AfterSaleAllocation',
    column_type: 'belongs_to',
    extra: {
      association_name: 'jushuitan_after_sale',
      model_name: 'JushuitanAfterSale',
    },
  },
  jushuitan_after_sale_id: {
    model_name: 'AfterSaleAllocation',
    column_type: 'belongs_to',
    extra: {
      association_name: 'jushuitan_after_sale',
      model_name: 'JushuitanAfterSale',
    },
  },
  received_amount: {
    model_name: 'AfterSaleAllocation',
    column_type: 'decimal',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
